import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { type ReactNode } from "react";

export function StoreSection({
  title,
  id,
  children,
}: {
  readonly title: string;
  readonly id?: string;
  readonly children: ReactNode;
}) {
  return (
    <section {...stylex.props(styles.section)}>
      <h2 id={id} {...stylex.props(styles.title)}>
        {title}
      </h2>
      {children}
    </section>
  );
}

const styles = stylex.create({
  section: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space16,
    borderTopWidth: { default: 1, ":first-child": 0 },
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    paddingTop: { default: spacing.space36, ":first-child": 0 },
    paddingBottom: { default: spacing.space36, ":last-child": 0 },
  },
  title: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.section,
    lineHeight: 1.15,
    fontWeight: 600,
    color: colors.foreground,
  },
});
